import { render, staticRenderFns } from "./contract.main.vue?vue&type=template&id=5c55e1ec&scoped=true&"
import script from "./contract.main.vue?vue&type=script&lang=js&"
export * from "./contract.main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c55e1ec",
  null
  
)

export default component.exports